module.exports = __webpack_public_path__ + "img/four1Red.22b97225.jpg";